// extracted by mini-css-extract-plugin
export default {"root":"_1-7BrAW2VYGeX7KZRmDdZ_","container":"_1R9pBnUkoMW-tousHGGTv-","text":"_2g48fJrZgDMU7PmZs2D6TU","logo":"reb0X1ASgS-fqFJaTqykV"};